const STORAGE_KEY = 'odus_customer_session';

export function getCustomerSession() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.userId || !data?.email) return null;
    return data;
  } catch {
    return null;
  }
}

export function setCustomerSession({ userId, email, fullName }) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      userId,
      email,
      fullName: fullName || '',
    })
  );
  window.dispatchEvent(new Event('odus-customer-session'));
}

export function clearCustomerSession() {
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new Event('odus-customer-session'));
}
